<template>
    <svg :class="className" width="11" height="7" viewBox="0 0 11 7">
        <path d="M8.76795 4.08487L7.06209
            5.64752C6.7904 5.91375 6.7904 6.34408 7.06209 6.61031C7.33448 6.87654 7.77539
            6.87654 8.04709 6.61031L10.6946 4.12708C10.8913 3.93371 11 3.67837 11 3.40465C11
            3.13161 10.8913 2.87491 10.6946 2.6829L8.04709 0.199673C7.77539 -0.0665576 7.33448
            -0.0665576 7.06209 0.199673C6.7904 0.465222 6.7904 0.896229 7.06209
            1.16246L8.76657 2.72307H0.687844C0.308154 2.72307 0 3.02811 0 3.40397C0 3.77982
            0.308154 4.08487 0.687844 4.08487H8.76795Z">
        </path>
    </svg>
</template>

<script>
export default {props: ['className']};
</script>
